import React from 'react';
import { Row } from 'antd';
import { StudentCard } from '@BUP/components';
import styles from './work-group-two-three.module.css';

const WorkGroupOfThreeCard = ({ dataGroup }) => {
  return (
    <Row gutter={[4, 8]} justify="space-around" className={styles.card_wrapper}>
      {dataGroup?.map((student) => (
        <StudentCard studentName={student.name} key={student.enrollmentId} />
      ))}
    </Row>
  );
};

export default WorkGroupOfThreeCard;
